import { render, staticRenderFns } from "./tenantAlgorithmicCalculation.vue?vue&type=template&id=51d4a997&scoped=true"
import script from "./tenantAlgorithmicCalculation.vue?vue&type=script&lang=js"
export * from "./tenantAlgorithmicCalculation.vue?vue&type=script&lang=js"
import style0 from "./tenantAlgorithmicCalculation.vue?vue&type=style&index=0&id=51d4a997&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d4a997",
  null
  
)

export default component.exports